
// Make `rails-ujs` able to detect jquery
import Rails from "@rails/ujs"
import jQuery from "jquery"


declare global {
  interface Window {
    _rails_loaded?: boolean
  }
}


jQuery.ajaxPrefilter((options, originalOptions, xhr) => {
  if (!options.crossDomain) {
    return Rails.CSRFProtection(xhr)
  }
})

const init = () => {
  // Avoid error message (although not sure what's the cause)
  if (window._rails_loaded) { return }

  Rails.start()
}


export default {
  init,
}
